import editor_choice from '../../assets/icons/editor_choice.svg'
import { RecognitionItem } from '../../utils/recognitions'

const PrizeBox = ({ year, award, organization }: Pick<RecognitionItem, 'year' | 'award' | 'organization'>) => {

    return (
        <div className="bg-primary-100 border border-brand-orange-20 rounded-sm relative w-full h-fill sm:w-[22.5rem] md:w-full">
            <div className="px-6 py-4 flex items-start flex-col gap-2 h-fill w-full ">
                <div className="w-[2.5rem] h-[2.5rem] ">
                    <img src={editor_choice} alt="price" />
                </div>
                <h5 className='text-brand-orange-20 text-hsmall'>{year} - {organization}</h5>
                <p className='text-primary-10 text-bmedium'>{award}</p>
            </div>
        </div>
    )
}

export default PrizeBox